import { FC, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Text from '@components/common/text';
import Button from '@components/common/button';
import { useToast } from '@components/common/toast';
import { useRenewAccessTokenRefreshToken } from '@repository/auth/useUserInfo';
import { useVerificationLongTermInActiveCheck } from '@repository/verification/useMobile';
import MobileForm from './mobileForm';
import AuthFindFormField from '@domain/rq/users/AuthFindFormField';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import { hasErrorMessage } from '@utils/typeGuard';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface Step2Props {
  onConfirm: () => void;
}

const Step2: FC<Step2Props> = ({ onConfirm }) => {
  const Toast = useToast();
  const { mutateAsync: updateVerificationLongTermInActiveCheck } = useVerificationLongTermInActiveCheck({
    onError: (e) => {
      if (hasErrorMessage(e)) {
        Toast({ type: 'error', iconType: 'info', content: e.response.data.message });
        setIsSuccessMobileAuth(false);
        reset();
      }
    },
  });
  const { mutateAsync: renewToken } = useRenewAccessTokenRefreshToken();
  const [isSuccessMobileAuth, setIsSuccessMobileAuth] = useState(false);

  const methods = useForm<AuthFindFormField>({ mode: 'onChange' });
  const { handleSubmit, getValues, reset } = methods;

  const onSubmit = async () => {
    try {
      await updateVerificationLongTermInActiveCheck(getValues());
      await renewToken();
      onConfirm();
    } catch (e: any) {}
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Text className={cx('noticeArea')} fontStyle={FontStyle.B2P_M} color={Colors.C_COOL_GRAY_70}>
          본인인증을 완료해 주세요.
        </Text>

        <MobileForm className={cx('mobileForm')} setIsSuccessMobileAuth={setIsSuccessMobileAuth} />

        <Button className={cx('confirmBtn')} disabled={!isSuccessMobileAuth}>
          잡다 시작하기
        </Button>
      </form>
    </FormProvider>
  );
};

Step2.displayName = 'Step2';
export default Step2;
